<template>
    <div style="margin-bottom:256px;">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>        
        <h3 class="text-center"> Registrar Nuevo Programa </h3>
        <form class="xcard" @submit.prevent="validarCampos" novalidate>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.idpostgrado')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> {{menu_name}}</div>
                            <input type="text" :value="postgrado.nombre" :disabled="true" class="form-control" placeholder="Seleccione">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.idpostgrado')"> {{validation.firstError('programa.idpostgrado')}} </div>
                    </div>
                    <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.idsede')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Sede</div>
                            <Sedes :model="programa" :default="$store.state.CARGO.sede" :bycargos="true"/>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.idsede')"> {{validation.firstError('programa.idsede')}} </div>
                    </div>
                    <div>
                        <label> <input type="radio" v-model="showauspicio" :value="0"> Sin auspicio <span style="margin-right:12px"></span> </label> 
                        <label> <input type="radio" v-model="showauspicio" :value="1"> Con auspicio </label>
                    </div>
                    <div v-if="showauspicio" class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.iduniversidad')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Universidad</div>
                            <Universidades :model="programa" v-bind:convenio="true"/>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.iduniversidad')"> {{validation.firstError('programa.iduniversidad')}} </div>
                    </div>
                    <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.gestion')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Gestion</div>
                            <Gestiones :model="programa"/>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.gestion')"> {{validation.firstError('programa.gestion')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.version')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Version</div>
                            <input type="text" v-model.trim="programa.version" class="form-control" placeholder="Ingrese el numero de version">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.version')"> {{validation.firstError('programa.version')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.grupo')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Grupo</div>
                            <input type="text" v-model.trim="programa.grupo" class="form-control" placeholder="Ingrese el numero de grupo">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.grupo')"> {{validation.firstError('programa.grupo')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Modalidad</div>
                            <select v-model="programa.modalidad" class="form-control">
                                <option value="S">Semi presencial</option>
                                <option value="P">Presencial</option>
                                <option value="V">Virtual</option>
                            </select>
                        </div>
                    </div>

                    <!-- ================== -->
                    <!-- SUBIDA DE ARCHIVOS -->
                    <!-- ================== -->
                    <div class="xcard">
                        <label><span class="text-danger">* </span> Imagen de la portada: </label>
                        <p>Esta imagen se muestra en la pagina web, Tamaño recomendado: 1200x1200 (cuadrado)</p>
                        <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('programa.portada')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon">
                                    <label for="portadaFile" class="btn btn-rounded btn-success">Seleccione una Imagen</label>
                                    <input style="visibility:hidden;" type="file" id="portadaFile" @click="resetPortadaUploader" @change="uploadPortadaImg" accept=".jpg, .jpeg, .png" ref="portadaFile" >
                                </div>
                            </div>
                            <input type="hidden" v-model.trim="programa.portada">
                            <div class="error" v-if="validation.hasError('programa.portada')"> {{validation.firstError('programa.portada')}}</div>
                        </div>
                        <div class="container-fluid">
                            <img class="img-responsive" alt="PORTADA" :src="location_programa_portadas+programa.portada">
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <p class="text-center text-primary"> Datos necesarios para poder inscribir. </p>
                    <small>Debe ingresar los montos totales con los que nace el programa.</small>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.cuotas')}">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Cantidad de Cuotas</div>
                            <input v-model.trim="programa.cuotas" type="text" class="form-control" placeholder="Numero entero">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.cuotas')"> {{validation.firstError('programa.cuotas')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.monto_matricula')}">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Monto de matricula</div>
                            <input v-model.trim="programa.monto_matricula" type="text" class="form-control" placeholder="Numero entero (total a pagar)">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.monto_matricula')"> {{validation.firstError('programa.monto_matricula')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.monto_colegiatura')}">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Monto de colegiatura</div>
                            <input v-model.trim="programa.monto_colegiatura" type="text" class="form-control" placeholder="Numero entero (total a pagar)">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.monto_colegiatura')"> {{validation.firstError('programa.monto_colegiatura')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.monto_certificacion')}">
                            <div class="input-group-addon"> Monto de certificacion</div>
                            <input v-model.trim="programa.monto_certificacion" type="text" class="form-control" placeholder="Numero entero (total a pagar)">
                        </div>
                        <div class="error" v-if="validation.hasError('programa.monto_certificacion')"> {{validation.firstError('programa.monto_certificacion')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.fecha_inicio')}">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Fecha de inicio</div>
                            <Fecha :model="programa" :valueto="'fecha_inicio'"/>
                            <!-- <input type="text" v-model="programa.fecha_inicio" class="form-control" placeholder="Formato DD/MM/YYYY"> -->
                        </div>
                        <div class="error" v-if="validation.hasError('programa.fecha_inicio')"> {{validation.firstError('programa.fecha_inicio')}} </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.fecha_fin')}">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Fecha de finalizacion</div>
                            <Fecha :model="programa" :valueto="'fecha_fin'"/>
                            <!-- <input v-model.trim="programa.fecha_fin" type="text" class="form-control" placeholder="Formato DD/MM/YYYY"> -->
                        </div>
                        <div class="error" v-if="validation.hasError('programa.fecha_fin')"> {{validation.firstError('programa.fecha_fin')}} </div>
                    </div>

                    <hr>
                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('programa.fase')}">
                            <div class="input-group-addon"> <span class="text-danger">* </span> Fase</div>
                            <select v-model.trim="programa.fase" class="form-control">
                                <option value="0">0 Pre inscripciones</option>
                                <option value="1">1 Inscripciones abiertas</option>
                                <option value="2">2 En Desarrollo</option>
                                <option value="3">3 Concluido</option>
                                <option value="4">4 Elaboracion de trabajos finales</option>
                                <option value="5">5 Recepcion de requisitos de titulacion</option>
                                <option value="6">6 Armado de carpetas</option>
                                <option value="7">7 Pago de aranceles</option>
                                <option value="8">8 Proceso de titulacion</option>
                                <option value="9">9 Certificados entregados</option>
                            </select>
                        </div>
                        <p> <small> <b>NOTA:</b> Solo se puede inscribir en fase de inscripciones abiertas y pre inscripciones. </small> </p>
                        <div class="error" v-if="validation.hasError('programa.fase')"> {{validation.firstError('programa.fase')}} </div>
                    </div>
                    <div v-show="false" class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Observacion: </div>
                        </div>
                        <textarea class="form-control" v-model.trim="programa.observacion" placeholder="Puede ingresar alguna observacion sobre este programa..." rows="5"></textarea>
                    </div> 
                    <div class="xcard">
                        <label> Imagen de Certificado (<a href="formato.psd" target="_blank" rel="">Descargar Formato ".psd" 1280x908 </a>)</label>
                        <div class="form-group form-group-sm">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon">
                                    <label for="certificadoFile" class="btn btn-rounded btn-primary">Seleccione un Certificado</label>
                                    <input type="file" style="visibility:hidden;" id="certificadoFile" @click="resetImageUploader" @change="uploadImageCert" accept=".jpg, .jpeg, .png" ref="certificadoFile" >
                                </div>
                            </div>
                            <input type="hidden" v-model.trim="programa.arte">
                            <div class="error" v-if="validation.hasError('programa.arte')"> {{validation.firstError('programa.arte')}}</div>
                        </div>
                        <div class="container-fluid">
                            <img class="img-responsive" alt="Certificado" :src="location_certificado_programa+programa.arte">
                        </div>
                    </div>
                </div>
            </div>

            <hr>
            <div class="xcard">
                <AModulos :model="programa" :importado="importado"/>
            </div>
            <br>

            <div class="xcard">
                <a class="btn btn-link" role="button" data-toggle="collapse" href="#collapseExamplem" aria-expanded="false" aria-controls="collapseExample">
                     <span class="glyphicon glyphicon-chevron-down"></span> Crear Nuevo Modulo (opcional)
                </a>
                <div class="collapse" id="collapseExamplem">
                    <NewModulo />
                </div>
            </div>
            <br>

            <Programas :model="importado" />
            <br>

            <Alertas ref="alertar" />
            <p class="text-center"> {{msg}} </p>
            <notifications group="auth" position="bottom right" />
            <notifications group="auth3" position="bottom right" />

            <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block" data-toggle="modal" data-target="#modal-confirmar"> <span class="glyphicon glyphicon-saved"></span> Registrar programa </button>
        </form>

    </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'
import { error, exito } from '@/components/Utils.js'
import xaxios from '@/xaxios'
import Sedes from '@/components/ASedes.vue'
import Universidades from '@/components/AUniversidades.vue'
import Gestiones from '@/components/AGestiones.vue'
import Alertas from '@/components/AAlertas.vue'
import AModulos from '@/components/ASelecionar-modulos.vue'
import Fecha from '@/components/AFecha'
import Programas from '@/components/AProgramas'
import NewModulo from '@/components/AModulosCrear'
import gql from 'graphql-tag'
export default {
    data() {
        return {
            menu_name: process.env.VUE_APP_NAME_MENU,
            location_certificado_programa: process.env.VUE_APP_URL_CERT_PROGRAMAS,
            location_programa_portadas: process.env.VUE_APP_URL_PORTADAS,
            form_valido: true,
            activo: true,
            universidades: [],
            postgrado: {categoria:{}},
            postgrados: [],
            sedes: [],
            gestiones: [],
            msg: '',
            importado:{ intereses:null },
            showauspicio: 1,
            programa: {
                version: 1,
                grupo: 1,
                portada: null,
                idpostgrado: null,
                idsede: null,
                iduniversidad: null,
                gestion: null,
                modalidad: 'S', // S,P,V

                arte: null,
                cuotas: null,
                fase: 0,
                monto_matricula: null,
                monto_colegiatura: null,
                monto_certificacion: null,
                fecha_inicio: null,
                fecha_fin: null,
                modulos:[],

                observacion:'',
            }
        };
    },
    components:{ Fecha,Sedes,Universidades,Gestiones,Alertas,AModulos,Programas,NewModulo },
    validators: {
        'programa.idpostgrado'(value){ return Validator.value(value).required(); },
        'programa.idsede'(value){ return Validator.value(value).required(); },
        //'programa.iduniversidad'(value){ return Validator.value(value).required(); },
        'programa.gestion'(value){ return Validator.value(value).required(); },
        'programa.version'(value){ return Validator.value(value).required().digit().maxLength(2); },
        'programa.grupo'(value){ return Validator.value(value).required().digit().maxLength(2);  },
        'programa.portada'(value){ return Validator.value(value).required(); },
        
        // 'programa.arte'(value){ return Validator.value(value).required(); },
        'programa.cuotas'(value){ return Validator.value(value).digit().required().greaterThan(0).lessThan(50); },
        'programa.fase'(value){ return Validator.value(value).digit().required().maxLength(1).lessThan(2); },
        'programa.monto_matricula'(value){ return Validator.value(value).digit().required().greaterThan(-1).lessThan(5000); },
        'programa.monto_colegiatura'(value){ return Validator.value(value).digit().required().greaterThan(-1).lessThan(90000); },
        'programa.monto_certificacion'(value){ return Validator.value(value).digit().greaterThan(-1).lessThan(90000); },
        
        'programa.fecha_inicio'(value){ return Validator.value(value).minLength(8).required() },
        'programa.fecha_fin'(value){ return Validator.value(value).minLength(8).required() },
    },
    watch:{
        programa: { 
            deep:true,handler(){ 
                window.sessionStorage.setItem( 'xprograma',JSON.stringify(this.programa) ); 
                //this.$refs.alertar.reset();
            } 
        },
        'programa.gestion': function(a){
            if( a== null && a.apertura!=null ) return;
            this.programa.fecha_inicio = a.apertura;
        },
        // NOMBRE_ARCHIVO: function(a){
        //     this.programa.portada = a;
        // }
    },
    methods:{
        resetPortadaUploader: function(){
            this.programa.portada = null;
            this.$refs.portadaFile.value = '';
        },
        uploadPortadaImg:function(){
            const img_cert = this.$refs.portadaFile.files[0];
            if (img_cert.size/1000 < 1024 ) {
                let url = `${process.env.VUE_APP_URL_WEBDATA}portada_upload.php`;
                let formData = new FormData();
                formData.append('file', img_cert);
                
                xaxios.post( url, formData,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(({data:{status, msg, newCertName}})=> {  // applying Destructuring js
                    this.programa.portada = status ? newCertName : null;
                    this.$notify( exito('PORTADA', `${msg} ${newCertName}` ) );
                    
                })
                .catch((error)=> {
                    this.resetPortadaUploader();
                    this.$notify( error( 'Error: '+url,error ) );
                });
            } else {
                this.resetPortadaUploader();
                this.$notify( error( 'Portada','El archivo debe ser Menor a 1MB' ) );
            }
        },
        resetImageUploader: function(){
            this.programa.arte = null;
            this.$refs.certificadoFile.value = '';
        },
        uploadImageCert:function(){
            const img_cert = this.$refs.certificadoFile.files[0];
            if (img_cert.size/1000 < 1024 ) {
                let url = `${process.env.VUE_APP_URL_WEBDATA}certificado_upload.php`;
                    
                let formData = new FormData();
                formData.append('file', img_cert);
                
                xaxios.post( url, formData,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(({data:{status, msg, newCertName}})=> {  // applying Destructuring js
                    this.programa.arte = status ? newCertName : null;
                    this.$notify( exito( 'CERTIFICADO', msg ) );
                })
                .catch((error)=> {
                    this.resetImageUploader();
                    this.$notify( error( 'Error: '+url,error ) );
                });
            } else {
                this.resetImageUploader();
                this.$notify( error( 'Certificado','El archivo debe ser Menor a 1MB' ) );
            }
        },
        parsePrograma( p ){
            if( p == null ) return "";
            var post = "";
            if( p != null  ) post = p.nombre;
            return post;
        },
        validarCampos(){
            this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.programa );
                if( obj.fase ) obj.fase = parseInt( obj.fase );
                if (success) {
                    obj.idsede = obj.idsede.id;
                    if( obj.iduniversidad ) obj.iduniversidad = obj.iduniversidad.id;
                    obj.version = parseInt( obj.version );
                    obj.gestion = obj.gestion.gestion;
                    obj.grupo = parseInt( obj.grupo );
                    if( obj.cuotas != null ) obj.cuotas = parseInt( obj.cuotas );
                    if( obj.monto_matricula != null ) obj.monto_matricula = parseInt( obj.monto_matricula );
                    if( obj.monto_colegiatura != null ) obj.monto_colegiatura = parseInt( obj.monto_colegiatura );
                    if( obj.monto_certificacion != null ) obj.monto_certificacion = parseInt( obj.monto_certificacion );
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');
                    //window.console.log( "HHHHHHHHHHHHHHHHHHHHHHHHHHH",window.stringifyObject(obj),this.showauspicio );
                    if( this.showauspicio == 0 ){
                        delete obj.iduniversidad;
                    }
                    //window.console.log( "HHHHHHHHHHHHHHHHHHHHHHHHHHH",window.stringifyObject(obj),this.showauspicio );
                    if( this.showauspicio && !obj.iduniversidad ){
                        this.$notify( error( 'Auspiciante','Debe seleccionar a la universidad auspiciante.' ) );
                        return;
                    }
                    if( !obj.portada.includes('.') ){
                        this.$notify( error( 'Portada','El nombre de la portada debe tener la extension.' ) );
                        return;
                    }
                    if( obj.modulos == null || obj.modulos.length == 0 ){
                        this.$notify( error( 'Sin modulos','Debe especificar los modulos de este programa.' ) );
                        return;
                    }else{
                        this.validarModulos( obj );
                    }
                    this.form_valido = true;
                    var vue = this;
                    obj.nombre_compuesto = this.parsePrograma(this.postgrado)+" v"+obj.version+" g"+obj.grupo+" "+obj.gestion+" s"+obj.idsede;
                    delete obj.observacion;
                    this.$dialog.confirm(this.$store.state.alertmsg).then(function() { vue.enviarDatos( obj )
                    }).catch(function() { vue.$refs.alertar.reset(); });
                    this.$refs.alertar.cargando();

                }else{
                    this.form_valido = false;
                    this.$refs.alertar.invalido();

                    // window.console.log( "HHHHHHHHHHHHHHHHHHHHHHHHHHH",window.stringifyObject(obj) );
                }
            });
        },
        validarModulos( obj ){ 
            var mods = [];
            obj.modulos.forEach( function(e){
                var ob = { idmodulo:e.id,numero:e.numero,inicio:e.inicio,fin:e.fin };
                if( ob.inicio == null ) delete ob.inicio;
                if( ob.fin == null ) delete ob.fin;
                mods.push( ob )
            });
            obj.modulos = mods;
        },
        enviarDatos( obj ){
            if( obj == null ) obj = JSON.parse( window.sessionStorage.getItem( 'xs_obj' ) );
            var vue = this;
            var sql = gql`mutation{ createPrograma(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
            vue.msg = '';
            // window.console.log( sql );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if(data.data.createPrograma.ok){
                    vue.$refs.alertar.success();
                    window.sessionStorage.setItem( 'xprograma',null );
                }else{
                    var errores = JSON.stringify(data.data.createPrograma.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    //vue.msg = vals;
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                
                // window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                vue.msg = error;
            })
        },
    },
    mounted(){
        /*if( sessionStorage.xprograma != undefined ) {
            var o = JSON.parse(sessionStorage.xprograma);
            if( o != null ) this.programa = o;
        }*/
        if( sessionStorage.xpostgrado != undefined ) {
            var ob = JSON.parse( window.sessionStorage.xpostgrado );
            if( ob != null ) {
                this.postgrado = ob;
                //window.console.log(ob)
                this.programa.idpostgrado = this.postgrado.id;
            }
        }

        // window.initArchivo( this.programa );
        // window.console.log( NOMBRE_ARCHIVO '+window.NOMBRE_ARCHIVO )
       // window.console.log( "nnnnnn",this.programa,this.postgrado )
    }
}
</script>